import { FC, ReactNode } from 'react';

import { FacetsPanelWrapper } from './FacetsPanel.styles';

type Props = {
    children: ReactNode;
    ariaLabel?: string;
    dataTest?: string;
};

export const FacetsPanel: FC<Props> = ({ children, ariaLabel, dataTest }) => {
    return (
        <FacetsPanelWrapper data-test={dataTest} aria-label={ariaLabel}>
            {children}
        </FacetsPanelWrapper>
    );
};
